(() => {
  const overlay = document.getElementById('avsp-shipping-overlay');
  if (!overlay || overlay.dataset.initialized === 'true') return;

  overlay.dataset.initialized = 'true';

  const closeButton = overlay.querySelector('.avsp-shipping-close');
  const sessionKey = 'avogel_shipping_popup_seen_v3';
  let previousFocus = null;
  let closeTimer = null;

  const hasSeen = () => {
    if (window.__avspShippingPopupShown === true) return true;

    try {
      return window.sessionStorage.getItem(sessionKey) === '1';
    } catch (error) {
      return false;
    }
  };

  const markSeen = () => {
    window.__avspShippingPopupShown = true;

    try {
      window.sessionStorage.setItem(sessionKey, '1');
    } catch (error) {
      // The in-memory fallback above still prevents repeat display in this tab.
    }
  };

  const getFocusableElements = () =>
    Array.from(
      overlay.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hasAttribute('hidden'));

  const openPopup = () => {
    if (hasSeen()) return;

    markSeen();
    previousFocus = document.activeElement;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('avsp-shipping-lock');

    window.requestAnimationFrame(() => {
      overlay.classList.add('avsp-is-open');
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  };

  const closePopup = () => {
    window.clearTimeout(closeTimer);
    overlay.classList.remove('avsp-is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('avsp-shipping-lock');

    closeTimer = window.setTimeout(() => {
      overlay.hidden = true;

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus({ preventScroll: true });
      }
    }, 190);
  };

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closePopup();
  });

  if (closeButton) closeButton.addEventListener('click', closePopup);

  document.addEventListener('keydown', (event) => {
    if (overlay.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements();
    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  if (!hasSeen()) window.setTimeout(openPopup, 650);
})();
